import { type LoadState } from "@/services/common";
import { type QuestionnaireSections } from "@/services/events";
import { defineStore } from "pinia";
import { ref } from "vue";
import { stateError, stateLoaded, stateLoading } from "./loadingStates";
import { Events as eventsApi } from "@inctec/elearning-ui-client";

export const useQuestionnaireStore = defineStore("questionnaire", () => {
  const questionnaireSectionsLoadStates = ref<
    Map<string, LoadState<QuestionnaireSections[]>>
  >(new Map());

  async function loadQuestionnaireSections(id: string, reload?: boolean) {
    const loadState = questionnaireSectionsLoadStates.value.get(id);
    if (!reload && (loadState?.loading || loadState?.loaded)) {
      return;
    }

    questionnaireSectionsLoadStates.value.set(id, { ...stateLoading });

    const response = await eventsApi
      .searchEventQuestionnaireSections({
        path: { questionnaireId: id },
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        questionnaireSectionsLoadStates.value.set(id, { ...stateError });
        throw error;
      });

    questionnaireSectionsLoadStates.value.set(id, {
      ...stateLoaded,
      result: response.result,
    });
  }

  function getQuestionnaireSectionLoadState(id: string) {
    return questionnaireSectionsLoadStates.value.get(id);
  }

  function reset() {
    questionnaireSectionsLoadStates.value = new Map();
  }

  return {
    questionnaireSectionsLoadStates,
    loadQuestionnaireSections,
    getQuestionnaireSectionLoadState,
    reset,
  };
});
